<template>
  <v-row no-gutters>

    <v-col cols="3">
      <v-container class="pa-1 bg-background2 overflow-auto split-scroll">
        <p class="pa-6 text-subtitle-2" v-if="tiles.length == 0">
          表示設定されているタイルがありません。設定画面からタイルを追加してください
        </p>

        <latest-tile v-for="tile in tiles" v-bind:key="tile.key"
          :loading="tile.isLoading"

          :name="tile.name"

          :alt-values="tile.altValues"

          :unit="tile.unit"

          :alarms="tile.alarms"

          :intervalMinutes="tile.intervalMinutes"

          :time="tile.time"
          :value="tile.value"
        ></latest-tile>
      </v-container>
    </v-col>

    <v-col cols="9">
      <v-container class="pb-2">
        <div class="pa-2" style="border: 1px dotted grey;">
          <v-row class="justify-center">
            <v-col cols="1" class="text-right">
              <v-menu v-model="isShowCalendar">
                <template v-slot:activator="{ props }">
                  <v-btn variant="plain" density="comfortable" icon="mdi-calendar-month-outline" v-bind="props" :disabled="isChartAutoScroll"></v-btn>
                </template>

                <vue-date-picker inline v-model="date" @update:model-value="isShowCalendar = false;"
                  locale="ja" week-start="0" :enable-time-picker="false" auto-apply></vue-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="3">
              <div class="mt-1 ms-4 text-h6">{{ formatDate(date) }}</div>
            </v-col>

            <v-col cols="2">
              <v-select variant="underlined" density="compact" class="mt-n3 text-h6" hide-details="true"
                v-model:model-value="hour" @update:model-value="syncHour" v-if="!isChartAutoScroll" :items="[
                  { title: '00時', value: '00' },
                  { title: '01時', value: '01' },
                  { title: '02時', value: '02' },
                  { title: '03時', value: '03' },
                  { title: '04時', value: '04' },
                  { title: '05時', value: '05' },
                  { title: '06時', value: '06' },
                  { title: '07時', value: '07' },
                  { title: '08時', value: '08' },
                  { title: '09時', value: '09' },
                  { title: '10時', value: '10' },
                  { title: '11時', value: '11' },
                  { title: '12時', value: '12' },
                  { title: '13時', value: '13' },
                  { title: '14時', value: '14' },
                  { title: '15時', value: '15' },
                  { title: '16時', value: '16' },
                  { title: '17時', value: '17' },
                  { title: '18時', value: '18' },
                  { title: '19時', value: '19' },
                  { title: '20時', value: '20' },
                  { title: '21時', value: '21' },
                  { title: '22時', value: '22' },
                  { title: '23時', value: '23' }
                ]"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="mt-1 me-3">mdi-clock-outline</v-icon>
                </template>
              </v-select>
            </v-col>

            <v-col cols="1" class="text-center">
              <div class="mt-1" v-if="!isChartAutoScroll">から</div>
            </v-col>

            <v-col cols="2">
              <v-select variant="underlined" density="compact" class="mt-n3 text-h6" hide-details="true"
                v-model:model-value="timeSpan" :items="TimeSpanList">
                <template v-slot:prepend-inner>
                  <v-icon class="mt-1 me-3">mdi-clock-start</v-icon>
                </template>
              </v-select>
            </v-col>

            <v-col cols="2" class="d-flex">
              <v-switch density="compact" color="primary" style="justify-items: end;" hide-details="true" v-model="isChartAutoScroll">
                <template v-slot:label>
                  <span class="text-subtitle-2">自動更新</span>
                </template>
              </v-switch>
            </v-col>
          </v-row>
        </div>
      </v-container>

      <v-container class="pa-1 overflow-auto split-scroll" style="height: calc(100dvh - 82px);">
        <p class="pt-6 text-subtitle-2 text-center" v-if="charts.length == 0">
          表示設定されているグラフがありません。設定画面からグラフを追加してください
        </p>

        <chart-area v-for="chart in charts"
          :key="chart.key"

          :id="chart.key"

          :hide-buttons="isChartAutoScroll"

          :start-datetime="startDatetime"
          :end-datetime="endDatetime"

          :time-span="timeSpan"

          :force-update="chartForceUpdate"

          :y-axis="chart.yAxis"

          :channels="chart.channels"

          :reference-lines="chart.referenceLines"

          @prev="prevSpan"
          @next="nextSpan"
        ></chart-area>
      </v-container>
    </v-col>

  </v-row>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import axios from 'axios';

import config from '@/config.js';

import LatestTile from '../components/LatestTile.vue';
import ChartArea from '../components/ChartArea.vue';

export default {
  name: 'MonitorView',
  components: {
    VueDatePicker,

    LatestTile,
    ChartArea
  },

  setup() {

    const tiles = ref([]);

    const charts = ref([]);

    const moduleIDSet = new Set();

    const tilesModuleIDSet = new Set();


    const isShowCalendar = ref(false);

    const hour = ref('00');

    const now = new Date();
    const date = ref(new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      parseInt(hour.value, 10)
    ));

    const TimeSpanList = ref([
      { title: '24h', value: 24 },
      { title: '12h', value: 12 },
      { title: '6h', value: 6 },
      { title: '3h', value: 3 },
      { title: '1h', value: 1 }
    ]);
    const timeSpan = ref(24);

    const isChartAutoScroll = ref(false);


    const savedDate = window.sessionStorage.getItem('monitor-view-date');
    if (savedDate != null) {
      date.value = new Date(
        parseInt(savedDate.split('-')[0], 10),
        parseInt(savedDate.split('-')[1], 10) - 1,
        parseInt(savedDate.split('-')[2], 10),
        parseInt(hour.value, 10)
      );
    }

    const formatDate = (date) => {

      const d = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours() + 9
      );

      return d.toISOString().substring(0, 10);
    };

    const calcStartDatetime = () => {

      if (isChartAutoScroll.value) {

        const d = new Date(
          date.value.getFullYear(),
          date.value.getMonth(),
          date.value.getDate(),
          date.value.getHours() + 9,
          date.value.getMinutes()
        );

        return d.toISOString().substring(0, 19);

      } else {
        return formatDate(date.value) + 'T' + hour.value + ':00:00';
      }

    };

    const calcEndDatetime = () => {
      const start = new Date(calcStartDatetime());

      let padMinutes = 0;
      if (isChartAutoScroll.value) {
        switch (timeSpan.value) {
          case 1:
            padMinutes = 10;
            break;

          case 3:
            padMinutes = 20;
            break;
        }
      }

      const end = new Date(
        start.getFullYear(),
        start.getMonth(),
        start.getDate(),
        start.getHours() + 9 + timeSpan.value,
        start.getMinutes() + padMinutes
      );

      return end.toISOString().substring(0, 19);
    };

    const startDatetime = ref(calcStartDatetime());
    const endDatetime = ref(calcEndDatetime());

    const chartForceUpdate = ref('');


    const prevSpan = () => {

      date.value = new Date(
        date.value.getFullYear(),
        date.value.getMonth(),
        date.value.getDate(),
        date.value.getHours() - timeSpan.value
      );

      hour.value = date.value.getHours().toString().padStart(2, '0');

    };

    const nextSpan = () => {

      date.value = new Date(
        date.value.getFullYear(),
        date.value.getMonth(),
        date.value.getDate(),
        date.value.getHours() + timeSpan.value
      );

      hour.value = date.value.getHours().toString().padStart(2, '0');

    };

    const syncHour = () => {
      date.value = new Date(
        date.value.getFullYear(),
        date.value.getMonth(),
        date.value.getDate(),
        parseInt(hour.value, 10)
      );
    };


    let intervalID;

    onMounted(() => {

      watch(date, () => {
        window.sessionStorage.setItem('monitor-view-date', formatDate(date.value));

        startDatetime.value = calcStartDatetime();
        endDatetime.value = calcEndDatetime();
      });

      watch(timeSpan, () => {
        endDatetime.value = calcEndDatetime();

        if (isChartAutoScroll.value) {
          scrollChart();
        }
      });

      watch(isChartAutoScroll, () => {
        if (isChartAutoScroll.value) {

          TimeSpanList.value = [
            { title: '3h', value: 3 },
            { title: '1h', value: 1 }
          ];

          timeSpan.value = 1;

          scrollChart();

        } else {

          TimeSpanList.value = [
            { title: '24h', value: 24 },
            { title: '12h', value: 12 },
            { title: '6h', value: 6 },
            { title: '3h', value: 3 },
            { title: '1h', value: 1 }
          ];

          hour.value = date.value.getHours().toString().padStart(2, '0');

          syncHour();

        }
      });

      const tilesSetting = window.localStorage.getItem('tiles-setting');
      if (tilesSetting != null) {
        tiles.value = JSON.parse(tilesSetting);
      }

      const chartAreasSetting = window.localStorage.getItem('chart-areas-setting');
      if (chartAreasSetting != null) {
        charts.value = JSON.parse(chartAreasSetting);
      }

      tiles.value.forEach((tile) => {
        moduleIDSet.add(tile.moduleID);
        tilesModuleIDSet.add(tile.moduleID);
      });

      charts.value.forEach((chart) => {
        chart.channels.forEach((channel) => {
          moduleIDSet.add(channel.moduleID);
        });
      });

      setChannelsInfo();

      reloadTiles();

      // TBD 最新値データ取得の周期設定
      intervalID = setInterval(() => {
        reloadTiles();

        if (isChartAutoScroll.value) {
          scrollChart();
        }

      }, 60000);

    });

    onBeforeUnmount(() => {
      clearInterval(intervalID);
    });

    const setChannelsInfo = () => {

      const promises = [];

      moduleIDSet.forEach((id) => {
        promises.push(
          axios.get(
            config.API_URL +
            `/modules/${ id }`,
            { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
          )
        );
      });

      Promise.all(
        promises
      ).then((values) => {

        const modulesInfo = {};

        values.forEach((value) => {
          modulesInfo[value.data.moduleID] = {
            channels: value.data.channels,
            missingDataCriteria: value.data.missingDataCriteria
          };
        });

        tiles.value.forEach((tile) => {

          if (tile.ch in modulesInfo[tile.moduleID].channels) {
            tile.name = modulesInfo[tile.moduleID].channels[tile.ch].name;


            tile.altValues = modulesInfo[tile.moduleID].channels[tile.ch].altValue;

            if (tile.ch.startsWith('do')) {
                tile.altValues = {
                  0: modulesInfo[tile.moduleID].channels[tile.ch].lowMeaning,
                  1: modulesInfo[tile.moduleID].channels[tile.ch].highMeaning
                };
            }


            tile.unit = modulesInfo[tile.moduleID].channels[tile.ch].unit;

            tile.alarms = modulesInfo[tile.moduleID].channels[tile.ch].alarms;

            tile.intervalMinutes = modulesInfo[tile.moduleID].missingDataCriteria.intervalMinutes;
          }

        });

        charts.value.forEach((chart) => {
          chart.channels.forEach((channel) => {
            if (channel.ch in modulesInfo[channel.moduleID].channels) {

              if (channel.ch.startsWith('d')) {
                channel.label = modulesInfo[channel.moduleID].channels[channel.ch].name;
              } else {
                channel.label = modulesInfo[channel.moduleID].channels[channel.ch].name
                  + '（' + modulesInfo[channel.moduleID].channels[channel.ch].unit + '）';
              }

              channel.intervalMinutes = modulesInfo[channel.moduleID].missingDataCriteria.intervalMinutes;

            }
          });
        });

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    const reloadTiles = () => {

      tiles.value.forEach((tile) => {
        tile.isLoading = true;
      });

      tilesModuleIDSet.forEach((id) => {

        axios.get(
          config.API_URL +
          `/modules/${ id }/latest`,
          { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
        ).then((response) => {

          if (response.data.time != null) {

            tiles.value.forEach((tile) => {
              if (tile.moduleID === response.data.moduleID) {

                if (tile.ch in response.data) {

                  tile.time = response.data.time;

                  const val = response.data[tile.ch].value;
                  tile.value = val.toString();

                  tile.isLoading = false;

                } else {
                  // TBD まだ一度もデータ送信されていない場合
                }

              }
            });

          } else {
            // TBD まだ一度もデータ送信されていない場合
          }

        }).catch((/* error */) => {
          // TBD リフレッシュトークンの利用を検討
          window.sessionStorage.clear();
          window.sessionStorage.setItem('access-token-expired', 'true');

          window.location.reload();
        });

      });

    };

    const scrollChart = () => {

      const now = new Date();

      let baseMinutes = now.getMinutes();

      while (baseMinutes % 5) {
        baseMinutes--;
      }

      if (timeSpan.value === 3 && baseMinutes % 10) {
        baseMinutes -= 5;
      }


      date.value = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours() - timeSpan.value,
        baseMinutes
      );


      chartForceUpdate.value = now.getTime().toString();

    };


    return {
      tiles,
      charts,

      isShowCalendar,
      date,
      hour,

      TimeSpanList,
      timeSpan,

      isChartAutoScroll,

      startDatetime,
      endDatetime,

      chartForceUpdate,

      prevSpan,
      nextSpan,
      formatDate,
      syncHour
    }
  }
}
</script>

<style scoped>
.split-scroll {
  height: 100dvh;
  /* scrollbar-width: none; */ /* for Firefox */
}

/* .split-scroll::-webkit-scrollbar {
  display: none;
} */
</style>
